export interface EventHandlerCallbacks {
    onSearch: () => void;
    onProcess: () => void;
    onShopifyClick: (row: JQuery<HTMLElement>, shopifyUrl?: string) => void;
    onShipClick: (row: JQuery<HTMLElement>, asset: any) => void;
    onAutoPopupChange: () => void;
}

export class ShippingEventHandlers {
    private barcodeInput = $("#so_barcode") as JQuery<HTMLInputElement>;
    private epcInput = $("#epc") as JQuery<HTMLInputElement>;
    private processButton = $(".process-btn");
    private autoPopupCheckbox = $("#auto-popup-in-eos") as JQuery<HTMLInputElement>;

    bindAll(callbacks: EventHandlerCallbacks): void {
        this.bindBarcodeInput(callbacks.onSearch);
        this.bindEpcInput(callbacks.onProcess);
        this.bindProcessButton(callbacks.onProcess);
        this.bindAutoPopupCheckbox(callbacks.onAutoPopupChange);
        this.bindFormSubmit(callbacks.onSearch);
        this.bindCustomEvents(callbacks.onShopifyClick, callbacks.onShipClick);
        
        setTimeout(() => {
            this.barcodeInput.removeAttr('tabindex');
        }, 100);
    }

    private bindBarcodeInput(onEnter: () => void): void {
        this.barcodeInput.on("keypress", (e: JQuery.KeyPressEvent) => {
            if (e.which === 13) {
                e.preventDefault();
                onEnter();
            }
        });
    }

    private bindEpcInput(onEnter: () => void): void {
        this.epcInput.on("keypress", (e: JQuery.KeyPressEvent) => {
            if (e.which === 13) {
                e.preventDefault();
                onEnter();
            }
        });
    }

    private bindProcessButton(onClick: () => void): void {
        this.processButton.on("click", (e: JQuery.ClickEvent) => {
            e.preventDefault();
            onClick();
        });
    }

    private bindAutoPopupCheckbox(onChange: () => void): void {
        this.autoPopupCheckbox.on("change", () => {
            onChange();
        });
    }

    private bindFormSubmit(onSubmit: () => void): void {
        $("form.sn-form").on("submit", (e: JQuery.SubmitEvent) => {
            e.preventDefault();
            onSubmit();
        });
    }

    private bindCustomEvents(
        onShopifyClick: (row: JQuery<HTMLElement>, shopifyUrl?: string) => void,
        onShipClick: (row: JQuery<HTMLElement>, asset: any) => void
    ): void {
        window.addEventListener('shopify-click', (e: any) => {
            onShopifyClick(e.detail.row, e.detail.shopifyUrl);
        });
        
        window.addEventListener('ship-confirm-click', (e: any) => {
            onShipClick(e.detail.row, e.detail.asset);
        });
    }

    getBarcodeInput(): JQuery<HTMLInputElement> {
        return this.barcodeInput;
    }

    getEpcInput(): JQuery<HTMLInputElement> {
        return this.epcInput;
    }

    getAutoPopupCheckbox(): JQuery<HTMLInputElement> {
        return this.autoPopupCheckbox;
    }
}

